import { Icon } from "@iconify/react";
import Form from "../components/form";

const ContactPage = () => {
  return (
    <>
      <div className="contact-page-container">
        <h1>Contact Us</h1>
        <div className="inner">
          <div className="form-cont">
            <Form formId="Contact" />
          </div>
          <div className="bubble">
            <h3>Stay in touch</h3>
            <div className="list">
              {/* <span>
                <Icon icon="ic-baseline-facebook" className="icon" />
                <p>@citoslearners</p>
              </span>*/}
              <a href="https://www.instagram.com/citoslearners?igsh=aWVveDBoYzlnNm9r">
                <span>
                  <Icon icon="mdi-instagram" className="icon" />
                  <p>@citoslearners</p>
                </span>
              </a>
              <a href="https://wa.me/message/F2IMLPUVCCRMP1">
                <span>
                  <Icon icon="ic:baseline-whatsapp" className="icon" />
                  <p>+44 7301 835689</p>
                </span>
              </a>

              <a href="https://www.tiktok.com/@citoslearners?_r=1&_t=ZN-91xHnMWe3Hi">
                <span>
                  <Icon icon="ic-baseline-tiktok" className="icon" />
                  <p>@citoslearners</p>
                </span>
              </a>
            </div>
            <img
              src="https://d1sq738v7irhr2.cloudfront.net/home/bubbles.webp"
              alt="bubbles"
              className="bubbles"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
